import { lazy } from 'solid-js'
import { messages } from '../../pages/booking-management-page/booking-management-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/booking-management-page/booking-management-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/bookings/:booking_id?',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showHostView: true,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
